<script setup>
import { reactive } from 'vue';

import router from '@/router';
import { toggleCorrectNavigationOption } from '@/store';
import { getAppointments } from '../firebase_files/appointment_functions';

import PatientDisplayLookupModalVue from './PatientDisplayLookupModal.vue';
import PatientDisplayInfoVue from './PatientDisplayInfo.vue';
import AppointmentDisplay from '@/components/AppointmentDisplay.vue';
import EditPatientVue from '@/patient/EditPatient.vue';

// declare vars


const state = reactive({
  patient:null,
  appointments: null,
  showPatientSelectModal: false, // toggles to true when user clicks edit patient

})


// main script
  toggleCorrectNavigationOption(); // highlights tab in nav bar
 
// declare functions
function goBack(){
  router.back();
}

function getHeaderText(){
  if(state.patient) return state.patient.name + "'s appointments";
  else return 'Patient Display';
}

/**
 * Code run when patient is found
 */
async function patientFound(pat){
  debugger
  const p = pat;
  state.patient = pat;
  state.appointments = await getAppointments(state.patient.cr);
}




</script>
<template>
  <!-- Editing patient -->
  <EditPatientVue v-if="state.showPatientSelectModal" :patient="state.patient"
  @cancel="state.showPatientSelectModal = false" @updatePatient="(p)=>state.patient=p"/>
  <!-- Looking up patient -->
  <PatientDisplayLookupModalVue v-if="!state.patient" 
  @setPatient="(pat)=>patientFound(pat)"
  @cancel="goBack()" />
  <!-- Viewing a patient -->
  <div v-else-if="state.patient && !state.showPatientSelectModal" class="patient-display-container">
    <PatientDisplayInfoVue :patient="state.patient" 
    @edit-patient="state.showPatientSelectModal=true" id="info"/>
    <AppointmentDisplay  v-if="state.appointments" :appointments="state.appointments" 
    :headerText="getHeaderText()" id="apt-display"/>
  </div>
  
</template>

<style lang="scss" scoped>
.patient-display-container{
  display: flex;
  justify-content: center; /* Center items horizontally */
  align-items: flex-start; /* Align items to the top of the container */
  height: 100vh; /* Set the height to 100% of the viewport height */
  
  #info{
    width: 30%;
    display: inline-block;
    // text-align: left;
  }
  #apt-display{
    width: 50%;
    display: inline-block;
    text-align: left;
  }
  #info, #apt-display{
    margin: 1rem;
  }
}
</style>